var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetupConnection(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4166 5.83325H13.9234C17.4785 5.83325 19.2561 5.83325 19.9308 6.47176C20.5141 7.02368 20.7726 7.83675 20.6151 8.62416C20.4329 9.5351 18.9817 10.5616 16.0793 12.6145L11.3373 15.9686C8.43481 18.0216 6.98357 19.0481 6.80139 19.959C6.64392 20.7464 6.9024 21.5595 7.48568 22.1114C8.16044 22.7499 9.938 22.7499 13.4931 22.7499H14.5833M9.33325 5.83325C9.33325 7.76625 7.76625 9.33325 5.83325 9.33325C3.90026 9.33325 2.33325 7.76625 2.33325 5.83325C2.33325 3.90026 3.90026 2.33325 5.83325 2.33325C7.76625 2.33325 9.33325 3.90026 9.33325 5.83325ZM25.6666 22.1666C25.6666 24.0996 24.0996 25.6666 22.1666 25.6666C20.2336 25.6666 18.6666 24.0996 18.6666 22.1666C18.6666 20.2336 20.2336 18.6666 22.1666 18.6666C24.0996 18.6666 25.6666 20.2336 25.6666 22.1666Z",
    stroke: "#414651",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetupConnection);
export default __webpack_public_path__ + "static/media/setupConnection.dad151e6d179613f4131a67f7a769c5e.svg";
export { ForwardRef as ReactComponent };